import { Equal } from "@assets/icons";
import { Checkbox } from "@components/ui/checkbox";
import {
  closestCenter,
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import React from "react";

interface DNDListProps {
  items: any[];
  setItems: (items: any) => void;
}

const SortableItem = ({
  id,
  disabled = true,
  setItems,
}: {
  id: any;
  disabled: boolean;
  setItems: (items: any) => void;
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: id.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    padding: "10px",
    margin: "5px 0",
    border: "1px solid #ccc",
    borderRadius: "5px",
    cursor: "grab",
    width: "100%",
  };

  return (
    <div
      ref={setNodeRef}
      className="w-full flex items-center  justify-between"
      style={{ ...style, cursor: disabled ? "pointer" : "grab" }}
      {...(!disabled ? { ...attributes, ...listeners } : {})}
    >
      <span className="flex items-center gap-[10px]">
        {!disabled && <Equal />} {id.name}
      </span>{" "}
      <Checkbox
        checked={id.checked}
        onCheckedChange={(e) =>
          setItems((items: any) =>
            items.map((item: any) =>
              item.id === id.id ? { ...item, checked: e } : item
            )
          )
        }
      />
    </div>
  );
};

const DNDCOMP: React.FC<DNDListProps> = ({ items, setItems }) => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    })
  );

  function handleDragEnd(event: any) {
    const { active, over } = event;

    if (active.id !== over?.id) {
      setItems((items: any) => {
        const oldIndex = items.findIndex((item: any) => item.id == active.id);
        const newIndex = items.findIndex((item: any) => item.id == over.id);
        return arrayMove(items, oldIndex, newIndex);
      });
    }
  }

  return (
    <div style={{ minWidth: "100%" }}>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext items={items} strategy={verticalListSortingStrategy}>
          {items.map((id) => (
            <SortableItem
              disabled={false}
              key={id.id}
              id={id}
              setItems={setItems}
            />
          ))}
        </SortableContext>
      </DndContext>
    </div>
  );
};

export default DNDCOMP;
